import "../assets/index-e0e6bab6.css";
import { A as i } from "../chunks/actionGlobal-8c1c28c9.mjs";
import { G as n } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { n as s } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const o = {
  name: "NcActionCheckbox",
  mixins: [i],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * id attribute of the checkbox element
     */
    id: {
      type: String,
      default: () => "action-" + n(),
      validator: (t) => t.trim() !== ""
    },
    /**
     * checked state of the the checkbox element
     */
    checked: {
      type: Boolean,
      default: !1
    },
    /**
     * value of the checkbox input
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * disabled state of the checkbox element
     */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "change",
    "check",
    "uncheck",
    "update:checked"
  ],
  computed: {
    /**
     * determines if the action is focusable
     *
     * @return {boolean} is the action focusable ?
     */
    isFocusable() {
      return !this.disabled;
    },
    /**
     * aria-checked attribute for role="menuitemcheckbox"
     *
     * @return {'true'|'false'|undefined} aria-checked value if needed
     */
    ariaChecked() {
      if (this.isInSemanticMenu)
        return this.checked ? "true" : "false";
    }
  },
  methods: {
    checkInput(t) {
      this.$refs.label.click();
    },
    onChange(t) {
      this.$emit("update:checked", this.$refs.checkbox.checked), this.$emit("change", t), this.$refs.checkbox.checked ? this.$emit("check") : this.$emit("uncheck");
    }
  }
};
var l = function() {
  var e = this, a = e._self._c;
  return a("li", { staticClass: "action", class: { "action--disabled": e.disabled }, attrs: { role: e.isInSemanticMenu && "presentation" } }, [a("span", { staticClass: "action-checkbox", attrs: { role: e.isInSemanticMenu && "menuitemcheckbox", "aria-checked": e.ariaChecked } }, [a("input", { ref: "checkbox", staticClass: "checkbox action-checkbox__checkbox", class: { focusable: e.isFocusable }, attrs: { id: e.id, disabled: e.disabled, type: "checkbox" }, domProps: { checked: e.checked, value: e.value }, on: { keydown: function(c) {
    return !c.type.indexOf("key") && e._k(c.keyCode, "enter", 13, c.key, "Enter") || c.ctrlKey || c.shiftKey || c.altKey || c.metaKey ? null : (c.preventDefault(), e.checkInput.apply(null, arguments));
  }, change: e.onChange } }), a("label", { ref: "label", staticClass: "action-checkbox__label", attrs: { for: e.id } }, [e._v(e._s(e.text))]), e._e()], 2)]);
}, r = [], d = /* @__PURE__ */ s(
  o,
  l,
  r,
  !1,
  null,
  "24834b9f",
  null,
  null
);
const m = d.exports;
export {
  m as default
};
